export default __webpack_public_path__ + "static/media/universe_hair_girl.fdaa0bdf.jpg";